import api, { API_VERSIONS } from "@/config/api";
import { RecordingCreationType, RecordingUUIDUser } from "@/models/recording";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { AxiosError } from "axios";

const postRecoverRecordingUUID = async (
  agendaId: string,
  recordingUUIDUsers: RecordingUUIDUser[],
  language: string,
  recordingType?: RecordingCreationType,
): Promise<string | AxiosError> => {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.post<
      string,
      {
        iBabsAgendaId: string;
        users: RecordingUUIDUser[];
        language: string;
        recordingType?: RecordingCreationType;
      }
    >(
      `/${API_VERSIONS.v0}/recording`,
      {
        iBabsAgendaId: agendaId,
        users: recordingUUIDUsers,
        language,
        recordingType,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${initialToken}`,
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error recovering recording UUID:", error);
    throw error;
  }
};

export default postRecoverRecordingUUID;
